import { Row } from 'react-table';
import { GenericTableDataFileDto } from 'inside-fifa/api/generic-tables/dto';

export const SheetsCell = ({ row }: { row: Row }) => (
    <ul>
        {(row.values as GenericTableDataFileDto).sheets.map(({ name }, index) => (
            <li key={index}>
                <code>{name}</code>
            </li>
        ))}
    </ul>
);
